<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/krqNr7/tc-custom/9780830898848.jpg?1696025895450" alt="This image is the cover for the book 'Return To Me', New Studies in Biblical Theology"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">'Return To Me', New Studies in Biblical Theology
      </h1>
      <p class="bookDescription body article font2">
        <p>"Return to me, says the LORD of hosts, and I will return to you," (Zech 1:3 ESV). Repentance concerns the repair of a relationship with God disrupted by human sin. All the major phases of church history have seen diversity and controversy over the doctrine. The first of Luther?s famous ninety-five theses nailed to the church door in Wittenburg in 1517 stated that 'the entire life of believers should be one of repentance'. In recent times, two divisive debates within evangelicalism over 'lordship salvation" and "hypergrace" have had repentance at their core. The theme of repentance is evident in almost every Old and New Testament corpus. However, it has received little sustained attention over the past half-century of scholarship, which has been largely restricted to word studies or focused on a particular text or genre. Studies of the overall theology of the Bible have typically given the theme only passing mention. In response, Mark Boda offers a comprehensive overview of the theological witness of Scripture to the theme of repentance in this New Studies in Biblical Theology volume. The key to understanding is not simply to be found in word studies, but also in the broader meaning of texts as these communicate through a variety of words, images and stories. The importance of repentance in redemptive history is emphasized. It is fundamentally a return to intimate fellowship with the triune God, our Creator and redeemer. This relational return arises from the human heart and impacts attitudes, words and actions. Addressing key issues in biblical theology, the works comprising New Studies in Biblical Theology are creative attempts to help Christians better understand their Bibles. The NSBT series is edited by D. A. Carson, aiming to simultaneously instruct and to edify, to interact with current scholarship and to point the way ahead.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mark J. Boda, D. A. Carson
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7f53fd4f